import React from "react";
import { Container, Row, Col } from "reactstrap";

function Testo1() {
  return (
    <>
      <div className="section section-dark">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
              <h2 className="title">Perchè utilizzare Node.js?</h2>
              <p className="description">
                Node.js, nato nel 2009, ha superato nel 2018 il miliardo di download e tutt'oggi è uno dei runtime più diffusi tanto che è presente in oltre 20 milioni di siti ed è utilizzato da milioni di aziende, tra queste anche alcune grandi come Spotify, Twitter, Netflix, PayPal, eBay, Reddit e LinkedIn.
                <br />La sua continua crescita è dovuta alle sue principali funzionalità in quanto si tratta di un sistema semplice, scalabile, e facilmente mantenibile oltre ad avere il grande vantaggio di essere multipiattaforma.
                <br />Questo runtime ci permette quindi di gestire:
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Testo1;
